module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"btnAddProposition":"Ajouter une proposition"},"en":{"btnAddProposition":"Add an answer"}}')
  delete Component.options._Ctor
}
